<template>
    <div class="container">
        <div class="row">
            <div class="col-12 offset-lg-2 col-lg-8">
                <panel class="mt-3">
                    <div class="h4 text-center text-uppercase fw-bold pt-3 pb-4">
                        {{t('header')}}
                    </div>
                    <form class="survey-customer-form" @submit.prevent="base_submit('model', 'submit')">

                        <form-item-selector v-model="model.service_rating"
                                            :label="t('model.service_rating.label')"
                                            :disabled="processing"
                                            :validator="v$.model.service_rating"
                                            :options="votes"></form-item-selector>

                        <form-textarea v-model="model.service_likes"
                                       :label="t('model.service_likes.label')"
                                       :disabled="processing"
                                       :placeholder="t('model.service_likes.placeholder')"
                                       :max-characters="1000"/>

                        <form-textarea v-model="model.service_improvements"
                                       :label="t('model.service_improvements.label')"
                                       :disabled="processing"
                                       :placeholder="t('model.service_improvements.placeholder')"
                                       :max-characters="1000"/>

                        <form-item-selector v-model="model.service_easy_to_follow"
                                            :label="t('model.service_easy_to_follow.label')"
                                            :disabled="processing"
                                            :validator="v$.model.service_easy_to_follow"
                                            :options="votes"/>

                        <div v-for="(group, index) in groups" :key="group.uuid">
                            <form-item-selector v-model="model.groups[index].setup_rating"
                                                :label="t('model.item.setup_rating.label', {name: products_translateProductName(group.product)})"
                                                :disabled="processing"
                                                :validator="v$.model.groups[index].setup_rating"
                                                :options="votes"/>

                            <form-textarea v-model="model.groups[index].comments"
                                           :label="t('model.item.comments.label', {name: products_translateProductName(group.product)})"
                                           :disabled="processing"
                                           :placeholder="t('model.item.comments.placeholder', {name: products_translateProductName(group.product)})"
                                           :max-characters="1000"/>
                        </div>

                        <div class="row">
                            <div class="col-12 offset-md-1 col-md-10">
                                <div class="mb-3 text-center">
                                    {{t('disclaimer')}}
                                </div>
                            </div>
                        </div>


                        <div class="mb-3 text-center pt-2">
                            <button type="submit" class="btn btn-sm btn-primary" :disabled="processing">
                                <spinner v-if="processing"></spinner>
                                {{processing ? t('button.submit.processing') : t('button.submit.cta')}}
                            </button>
                        </div>
                    </form>
                </panel>
            </div>
        </div>
    </div>
</template>

<script>

    import {v4 as uuidv4} from "uuid";
    import {pick} from "lodash/object";
    import useVuelidate from "@vuelidate/core";
    import {required} from "@vuelidate/validators"

    import mixin_view from "@/mixins/view";
    import mixin_products from "@/mixins/products";
    import {retryRequest} from "@/helpers/request";

    import Panel from "@/components/Panel";
    import FormTextarea from "@/components/form/FormTextarea";
    import FormItemSelector from "@/components/form/FormItemSelector";

    export default {
        name: "ViewsSurveyCustomer",
        mixins: [mixin_view, mixin_products],
        components: {
            FormItemSelector,
            FormTextarea,
            Panel
        },
        setup() {
            return {
                v$: useVuelidate()
            }
        },
        data() {

            return {
                t_path: "views.survey.customer",
                processing: false,
                votes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => ({value: i, name: i})),
                items: [],
                groups: [],
                model: {
                    order_id: null,
                    reference_ids: null,
                    service_rating: null,
                    service_likes: null,
                    service_improvements: null,
                    service_easy_to_follow: null,
                    groups: []
                }
            }
        },
        validations() {

            const model = {
                service_rating: {
                    required,
                },
                service_easy_to_follow: {
                    required,
                },
                groups: {}
            };

            this.model.groups.forEach((group, index) => model.groups[index] = {
                setup_rating: {
                    required
                }
            });

            return {
                model,
            }
        },
        methods: {
            submit() {

                this.processing = true;

                const request = {
                    order_id: this.model.order_id,
                    reference_ids: this.model.reference_ids,
                    service_rating: this.model.service_rating,
                    service_likes: this.model.service_likes,
                    service_improvements: this.model.service_improvements,
                    service_easy_to_follow: this.model.service_easy_to_follow,
                    items: this.model.groups.reduce(
                        (result, group, index) => {

                            this.groups[index].references.forEach(referenceId => {
                                result.push({
                                    id: this.items.find(item => item.reference_id = referenceId)._id,
                                    setup_rating: group.setup_rating,
                                    comments: group.comments
                                })
                            })

                            return result;
                        },
                        []
                    )
                }

                return retryRequest(() => this.$delivery.post("/survey", request))
                    .then(() => this.$router.push({name: "delivery.submitted"}))
                    .catch(error => this.base_error(error))
                    .finally(() => this.processing = false);
            },
            fetch() {

                this.items = this.$session.get(this.$route.query.itemsReference, []);
                this.model.order_id = this.$route.query.order_id;
                this.model.reference_ids = this.items.map(item => item.reference_id);

                // Group items by order id, tracking and product sku
                this.groups = this.items.reduce(
                    (result, item) => {

                        // check for we already have a group with this product and tracking
                        const index = result.findIndex(resultItem => resultItem.sku === item.sku);

                        if (-1 !== index) {

                            result[index].references.push(item.reference_id);
                        } else {

                            result.push({
                                uuid: uuidv4(),
                                sku: item.sku,
                                references: [item.reference_id],
                                product: pick(item, ["name", "generic_name", "lang_overrides"])
                            })
                        }

                        return result;
                    },
                    []
                );

                this.model.groups = this.groups.map(group => ({
                    comments: null,
                    setup_rating: null
                }));
            }
        },
        mounted() {

            this.fetch();
        }
    }
</script>